import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import moment from 'moment';


const mapLineToApiLineDto = (values: ICreateLineForm): IPostNewLine | {} => {
  let dataMapping: IPostNewLine ;
  const unknown = -1;

    dataMapping = {
      applProtocolNumber: values.applProtocolNumber,
      applDate: values.applDate ? `${moment(values.applDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null ,
      offApplDate: values.offApplDate ? `${moment(values.offApplDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null  ,
      deliveryDate: values.deliveryDate ? `${moment(values.deliveryDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null  ,
      pendingStatusID: +values.pendingStatusID !== 0 ? +values.pendingStatusID : null ,
      providerID: +values.providerID !== 0 ? +values.providerID : unknown,
      lineTypeID: +values.lineTypeID !== 0 ? +values.lineTypeID : unknown,
      comments: values.comments,
      usedByID: +values.usedByID !== 0 ? +values.usedByID : null,
      sapCode: values.sapCode,
      isEmporiki: values.isEmporiki,
      isCiti: values.isCiti,
      lineType: 2,
      costByID: +values.costByID !== 0 ? +values.costByID : unknown,
      speedID: +values.speedID !== 0 ? +values.speedID : unknown,
      cost: +values.cost !== 0 ? +values.cost : 0,
      endA: +values.endA,
      endB: +values.endB !== 0 ? +values.endB : unknown,
      hcNmsNum: values.hcNmsNum,
      hcNum1: values.hcNum1,
      hcNum2: values.hcNum2,
      accNum1: values.accNum1,
      accNum2: values.accNum2,
      coupleNumA1: values.coupleNumA1,
      coupleNumB1: values.coupleNumB1,
      coupleNumA2: values.coupleNumA2,
      coupleNumB2: values.coupleNumB2,
      phoneNumber: values.phoneNumber,
      descline: values.descline,
      bulkPhoneNumbersAdd: 1,
    }
  
  return dataMapping;
}


export const createLine = ( {data} : {data: ICreateLineForm }): Promise<string> => {
  const line = mapLineToApiLineDto(data);
  return axiosDefaultApi.post(`/api/ComLines/InsertComLine`, line);
};

type QueryFnType = typeof createLine;

type UseCreateLineOptions = {
  data: IPostNewLine | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateLine = ({ config }: UseCreateLineOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Γραμμής Data.`, 500);
            console.error('Couldnt create new store', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllLines"])
            addNotification(`Η Γραμμή Data Δημιουργήθηκε.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createLine,
    })
}